import {
  useUniqueClosesByAgentQuery,
} from '../../../../../../../../shared';
import moment from 'moment';



export const useUniqueClosesByAgentId = (agentId?: string) => {

  const {data: newData, previousData, loading} = useUniqueClosesByAgentQuery({
    variables: {
      agentId,
      currentRange: {from: moment().startOf('month').toISOString(), to: moment().endOf('day').toISOString()},
      previousRange: {from: moment().subtract(1, 'month').startOf('month').toISOString(), to: moment().subtract(1, 'month').endOf('day').toISOString()},
    },
    fetchPolicy: 'cache-and-network',
    skip: !agentId
  })

  const previous = newData?.previous.totalElements || previousData?.previous.totalElements;
  const current = newData?.current.totalElements || previousData?.current.totalElements;

  return {
    previous,
    current,
    loading
  };
}
